import PropertyRoomPriceListCard from './PropertyRoomPriceListCard';

export default PropertyRoomPriceListCard;
